export default __webpack_public_path__ + "static/media/09.c9dcb992.mp3";